import React from 'react';
import { Box, Grid } from '@material-ui/core';
import Button from 'on_web/components/shared/Common/Button';
import { trackEvent } from 'on_web/helpers/userTrackingEventsHelper';
import { COOL_BLUE } from 'colours';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

export default function ScheduleEnterpriseDemoBanner(props) {
  const useStyles = makeStyles(theme => ({
    content: {
      fontFamily: 'MuseoSans-500',
      fontSize: 14,
      lineHeight: '18px',
      color: '#ffffff',
      textAlign: 'left',
      backgroundColor: COOL_BLUE,
    },
  }));

  const classes = useStyles();
  const history = useHistory();

  return (
    <>
      <Box className={classes.content}>
        <Box p={'20px'}>
          <span>
            Get a better understanding of your COVID-19 risk! The enterprise
            (100+ person) version of SPARE includes DNA-based risk assessments
            for almost 50 additional risk factors associated with COVID-19
            vulnerability and severity risk.
          </span>
        </Box>
        <Box px={'20px'} style={{ paddingBottom: '25px' }} textAlign="center">
          <Button
            variant="outlined"
            endIcon={<NavigateNextIcon />}
            style={{
              paddingLeft: '25px',
              paddingRight: '25px',
              paddingTop: '5px',
              paddingBottom: '5px',
              textTransform: 'uppercase',
              outlinedBorderColor: '#ffffff',
              color: '#ffffff',
            }}
            onClick={() => {
              trackEvent('Reporting', 'Schedule enterprise demo click on Home');
              window.open(
                'https://lifenome.pipedrive.com/scheduler/KkEkRlSz/spare-demo',
                '_blank'
              );
            }}
          >
            {'Schedule enterprise demo'}
          </Button>
        </Box>
      </Box>
    </>
  );
}
